import Avatar from '@atlaskit/avatar';
import Tile from '@atlaskit/tile';
import { Text } from '@atlaskit/primitives';
import { useToken } from '../../../../Flow/ConsentContextProvider';

const isDefaultAvatar = (logoUrl?: string): boolean => {
  if (!logoUrl) return true;
  return logoUrl.endsWith('/default-avatar.png');
};

const Logo = () => {
  const { clientLogoUrl, clientName } = useToken();
  
  // If custom logo provided and not a default avatar, use it
  if (clientLogoUrl && !isDefaultAvatar(clientLogoUrl)) {
    return (
      <Avatar src={clientLogoUrl} size="large" name={clientName ?? undefined} />
    );
  }

  // Otherwise, show client name with branded background
  const initials = clientName
    ?.split(' ')
    .map((word) => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2) || '?';

  return (
    <Tile label={clientName ?? ''} size="large" backgroundColor="color.background.brand.bold">
      <Text align="center" color="color.text.inverse">{initials}</Text>
    </Tile>
  );
};

export default Logo;
